var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayFecFields)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true}}],staticClass:"bi bi-exclamation-triangle-fill fec-icon text-orange",style:({ 'font-scale': _vm.fontScale })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }